// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__FNOLPolicySearch__buttonContainer{margin-top:2em}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/twia-capability-fnol-common-react/components/FNOLPolicySearch/FNOLPolicySearch.module.scss"],"names":[],"mappings":"AAAA,wCACE,cAAA","sourcesContent":[".buttonContainer {\n  margin-top: 2em;;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonContainer": "app__FNOLPolicySearch__buttonContainer"
};
export default ___CSS_LOADER_EXPORT___;
